import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

// animación de la paginación
const getTranslate = () => state => state.moveX * state.active;

const StyledPagination = styled.div`
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
     max-width: ${rem('562px')};
  `};
`;

const StyledWrapperCarousel = styled.div`
  overflow-x: auto;
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};

  ${mediaqueries.greaterThan('desktop')`
    overflow: hidden;
  `};
`;

const StyledCarousel = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    transition: transform 0.5s ease-in-out;
    transform: translate(-${getTranslate}px);
  `};
`;

const StyledList = styled.ul`
  margin: ${rem('15px')} ${rem('10px')} 0 0;
  padding: 0;
  display: flex;
  justify-content: flex-end;
  ${mediaqueries.greaterThan('tablet')`
    margin-right: 0;
  `};
`;

const StyledPage = styled.li`
  list-style: none;
  width: ${rem('13px')};
  height: ${rem('13px')};
  padding: 0;
  background-color: ${props => props.theme.colors.grayLight};
  margin-left: ${rem('28px')};
  transition: 0.5s;

  &:first-child {
    margin-left: 0;
  }

  &:before {
    display: none;
  }

  &:nth-child(${state => state.active}) {
    background-color: ${props => props.theme.colors.grayDarkest};
  }

  &.active {
    background-color: ${props => props.theme.colors.grayDarkest};
  }

  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('10px')};
    height: ${rem('10px')};
    margin-left: ${rem('10px')};
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.colors.grayDarkest};
    }
  `};
`;

export {
  StyledPagination,
  StyledWrapperCarousel,
  StyledCarousel,
  StyledList,
  StyledPage
};
